import { types as sdkTypes } from '../../util/sdkLoader';
import type { MapPin } from './types';

const { LatLng: SDKLatLng, LatLngBounds: SDKLatLngBounds } = sdkTypes as any;

// Fallback viewport when no listings have geolocation
export const DEFAULT_BOUNDS = new SDKLatLngBounds(
  new SDKLatLng(49.38, -66.95),
  new SDKLatLng(24.52, -124.39)
);

// Build a viewport that fits all pins. Falls back to DEFAULT_BOUNDS when empty.
export const boundsFromPins = (pins: MapPin[]) => {
  if (!pins.length) return DEFAULT_BOUNDS;
  const lats = pins.map(p => p.lat);
  const lngs = pins.map(p => p.lng);
  const pad = 1;
  return new SDKLatLngBounds(
    new SDKLatLng(Math.min(Math.max(...lats) + pad, 85), Math.min(Math.max(...lngs) + pad, 180)),
    new SDKLatLng(Math.max(Math.min(...lats) - pad, -85), Math.max(Math.min(...lngs) - pad, -180))
  );
};

export const DISTANCE_STEPS = [5, 10, 15, 25, 50, 75, 100, 150] as const;


export const zoomForRadiusMiles = (r: number): number => {
  if (r <= 5) return 12;
  if (r <= 10) return 11;
  if (r <= 15) return 10.5;
  if (r <= 25) return 10;
  if (r <= 50) return 9;
  if (r <= 75) return 8.5;
  if (r <= 100) return 8;
  return 7;
};

// MapPin SVG inline (matches lucide-react MapPin)
export const MAP_PIN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>`;

// Shared CSS strings: built once, not on every marker creation
export const CLUSTER_BUBBLE_BASE =
  'display:inline-flex;align-items:center;justify-content:center;' +
  'background:hsl(var(--primary));color:hsl(var(--primary-foreground));' +
  'border-radius:50%;box-shadow:0 4px 14px rgba(0,0,0,0.3);' +
  'border:3px solid hsl(var(--background));font-weight:700;font-size:13px;' +
  'font-family:inherit;transition:transform 0.15s;user-select:none;';

export const PIN_STYLE =
  'display:inline-flex;align-items:center;justify-content:center;' +
  'background:hsl(var(--primary));color:hsl(var(--primary-foreground));' +
  'padding:8px;border-radius:50%;box-shadow:0 4px 12px rgba(0,0,0,0.25);' +
  'border:2px solid hsl(var(--background));transition:transform 0.15s;line-height:0;';

export const WRAPPER_STYLE =
  'display:inline-flex;align-items:center;justify-content:center;cursor:pointer;outline:none;';
